/**
 * 大师测试页（/seer/master-fortune）前端页面数据层。
 *
 * 职责：
 * - 对外统一导出页面数据类型与 builder（供 BFF、composable 复用）
 * - 通过 Nitro BFF 拉取已聚合、已整形的页面数据
 *
 * 数据流：页面 composable → 本文件 fetch* → /seer/api/page/master-fortune → 后端多接口
 */

// 类型与 builder 统一从此文件 re-export，避免调用方直接依赖 builders 目录
export type {
	MasterFortunePcPageData,
	MasterFortuneMobilePageData,
} from "~/utils/page-data/builders/master-fortune";
export {
	transformTeacherEvaluateList,
	transformRankingList,
	buildMasterFortunePcPageData,
	buildMasterFortuneMobilePageData,
} from "~/utils/page-data/builders/master-fortune";

import type {
	MasterFortuneMobilePageData,
	MasterFortunePcPageData,
} from "~/utils/page-data/builders/master-fortune";
import { fetchPageBff } from "~/utils/page-data/client-fetch";

/** PC 大师测试页：评价列表、排行榜、资源位老师、课程列表等 */
export async function fetchMasterFortunePcPageData(): Promise<MasterFortunePcPageData> {
	return fetchPageBff<MasterFortunePcPageData>("/seer/api/page/master-fortune", {
		platform: "pc",
	});
}

/**
 * 移动大师测试页：导师列表、讲座列表及分页信息。
 * @param sortType 导师排序字段，默认按订单量 order_count
 */
export async function fetchMasterFortuneMobilePageData(
	sortType = "order_count"
): Promise<MasterFortuneMobilePageData> {
	return fetchPageBff<MasterFortuneMobilePageData>("/seer/api/page/master-fortune", {
		platform: "mobile",
		sortType,
	});
}
